import { pricingCalculator as store } from 'store';

export const getInputControls = (type, label) => {
  const getDefaultValue = () => {
    switch (type) {
      case 'checkbox':
        return [];
      case 'counter':
        return {};
      default:
        return '';
    }
  };

  const fieldValue = store.getFieldValue(label) ?? getDefaultValue();

  const getValue = target => {
    switch (type) {
      case 'counter':
        return fieldValue[target] ?? 0;
      case 'radio':
        return fieldValue === target;
      default:
        return fieldValue?.includes(target);
    }
  };

  const handleChange = (target, value) => {
    let result;

    switch (type) {
      case 'radio':
        result = target;
        break;
      case 'counter':
        result = { ...fieldValue };
        if (value === 0) {
          delete result[target];
        } else {
          result[target] = value;
        }
        break;
      default:
        result = [...fieldValue];
        if (!fieldValue.includes(target)) {
          result.push(target);
        } else {
          result = result.filter(item => item !== target);
        }
        break;
    }

    store.setFieldValue(label, result);
  };

  return {
    getValue,
    handleChange,
  };
};

export const getAdditionalFormData = (steps, analyticsEvent) => {
  store.setIsSubmitting(true);
  const payload = store.getPayload();
  if (!Object.values(payload).flat().length) {
    return;
  }

  const calculatorData = [];

  steps.forEach(({ label, type }) => {
    const storeData = payload[label];

    if (storeData) {
      const result = {
        label,
        type,
      };

      if (Array.isArray(storeData)) {
        result.data = storeData.map(item => ({ label: item, value: true }));
      } else if (type === 'counter') {
        result.data = Object.entries(storeData).map(([label, value]) => ({ label, value }));
      } else {
        result.value = storeData;
      }
      calculatorData.push(result);
    }
  });

  if (analyticsEvent) {
    calculatorData.push({
      label: 'approximate-price',
      type: 'approximatePrice',
      value: store.price,
    });
  }

  return {
    calculatorData,
  };
};

export const getCountersHandlers = (onChangeCount, defaultValue = 0) => {
  const increment = (key, value) => {
    const count = value + 1;

    onChangeCount(key, count > 99 ? 99 : count);
  };

  const decrement = (key, value) => {
    const count = value - 1;

    onChangeCount(key, count > defaultValue ? count : defaultValue);
  };

  return { increment, decrement };
};

export const parseDesktopSummary = activeSection => {
  const result = [];

  if (activeSection) {
    const { summaryTitle, button, steps } = activeSection;
    result.push({ summaryTitle, label: button });

    steps.forEach(value => {
      result.push({ summaryTitle: value.summaryTitle, label: value.label });
    });
  }

  return result;
};

export const parseMobileSummary = (items, businessNeed, t) => {
  const result = [businessNeed];

  items.forEach(([key, value]) => {
    if (key === 'duration') {
      result.push(`${value} ${t('months')}`);
      return;
    }
    if (Array.isArray(value)) {
      result.push(...value);
      return;
    }

    if (typeof value === 'object') {
      Object.entries(value).forEach(([counter, number]) => result.push(`${counter} (${number})`));
      return;
    }

    result.push(value);
  });

  return { summaryContent: result.join(', '), summaryCount: result.length };
};
